import {
  CmSheetStateEnum,
  cmSheetStatesOrdered,
} from "../constants/AppConstants";

export const currentStateIsMoreThanTargetState = (
  currentState: CmSheetStateEnum,
  targetState: CmSheetStateEnum,
) => {
  const indexCurrentState = cmSheetStatesOrdered.indexOf(currentState);
  const indexTargetState = cmSheetStatesOrdered.indexOf(targetState);
  return indexCurrentState > indexTargetState;
};

export const currentStateIsMoreEqualThanTargetState = (
  currentState: CmSheetStateEnum,
  targetState: CmSheetStateEnum,
) => {
  const indexCurrentState = cmSheetStatesOrdered.indexOf(currentState);
  const indexTargetState = cmSheetStatesOrdered.indexOf(targetState);
  return indexCurrentState >= indexTargetState;
};

export const currentStateIsLessThanTargetState = (
  currentState: CmSheetStateEnum,
  targetState: CmSheetStateEnum,
) => {
  const indexCurrentState = cmSheetStatesOrdered.indexOf(currentState);
  const indexTargetState = cmSheetStatesOrdered.indexOf(targetState);
  return indexCurrentState < indexTargetState;
};

export const currentStateIsLessEqualThanTargetState = (
  currentState: CmSheetStateEnum,
  targetState: CmSheetStateEnum,
) => {
  const indexCurrentState = cmSheetStatesOrdered.indexOf(currentState);
  const indexTargetState = cmSheetStatesOrdered.indexOf(targetState);
  return indexCurrentState <= indexTargetState;
};
